import { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { statisticsService, type StatisticsResponse } from '../services/dashboardService';


export const StatisticsContext = createContext<StatisticsResponse | null>(null);

export function useStatistics() {
  return useContext(StatisticsContext);
}

export function StatisticsProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading, error } = useQuery<StatisticsResponse>({
    queryKey: ['dashboard-statistics'],
    queryFn: statisticsService.getStatistics,
  });

  return (
    <StatisticsContext.Provider value={data ?? null}>
      {children}
    </StatisticsContext.Provider>
  );
}